<template>      
    <div id="ubn" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('departure.UBN') }}</h5>        
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-8">
            <div class="input-group input-group-static null">
                <label>{{ $t('departure.UBN') }}</label>
                <input v-model="state.departureFromLocation" type="text" class="form-control form-control-default" disabled>
            </div>
          </div>
        </div>
      </div>
    </div>    
    <div id="animal" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('departure.Animal') }}</h5>
        <p class="mb-0 text-sm">{{ $t('departure.NB_21_days_rule') }}</p>        
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-12">
            <div class="mb-4">
              <p class="fw-bold text-sm">{{ $t('departure.Selected_animals') }}</p>
              <div class="row">
                <div v-for="animal in state.departure.animals" :key="animal.id" class="col-md-6 mb-1">
                  <div class="card border  text-sm border-success bg-light">
                    <span v-html="displayText(animal)"></span>                    
                  </div>
                </div>                
              </div>
            </div>
          </div>
        </div>        
      </div>
    </div>
    <div id="ubnto" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('departure.Departure_UBN') }}</h5>
        <p class="mb-0 text-sm">{{ $t('departure.NB_UBN_outside_studboek') }}</p>        
      </div>
      <div class="card-body pt-0">   
        <div class="row">          
          <div class="col-6">
              <div class="input-group input-group-static null">
                  <label>{{ $t('departure.Departure_UBN') }}</label>
                  <input v-model="state.departureToLocation" type="text" class="form-control form-control-default" disabled>
              </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('departure.Departure_UBN_outside_studboek') }}</label>
                <input v-model="state.departureToUBN" type="text" class="form-control form-control-default" disabled>
              </div>
          </div>
        </div>
        <div class="row mt-3" v-if="userRoleName == 'Admin' || userRoleName == 'AssociationAdmin'">
          <div class="col-6">
              <div class="input-group input-group-static null">
                  <label>{{ $t('departure.Export_country') }}</label>
                  <input v-model="state.exportCountry" type="text" class="form-control form-control-default" disabled>
              </div>
          </div>
        </div>        
      </div>
    </div>
    <div id="date" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('departure.Departure_Date') }}</h5>        
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('departure.Departure_Date') }}</label>
                <input v-model="state.occurrenceDate" type="text" class="form-control form-control-default" disabled>
            </div>
          </div>          
        </div>        
      </div>    
    </div>      
  </template>
  
  <script>
  import axios from 'axios'  
  import { reactive, computed, ref, watch } from 'vue'  

  export default {
    name: "DepartureOverviewItem",
    setup() {

      const state = reactive ({        
        gets: [],
        departure:[],

        id: '',
        type: '',

        occurrenceDate: null,
        departureFromLocation: '',
        departureToLocation: '',
        departureToUBN: '',
        exportCountry: ''
    })
    
    const toStr = v => (v == null ? '' : String(v))

    const isDepartureUbnTyped = computed(() => toStr(state.departureUbn).trim().length > 0)
    const isDepartureUbnSelected = computed(() => !!state.departureUbnId)    
    
    watch(() => state.departureUbnId, (val) => {
      if (val) state.departureUbn = ''
    })

    watch(() => state.departureUbn, (val) => {
      const typed = toStr(val).trim()
      if (typed) {
        state.departureUbnId = ''
        // if using Choices.js, also disable its UI:
        if (typeof window !== 'undefined' && this?.choicesInstanceDepartureUBN) {
          try { this.choicesInstanceDepartureUBN.removeActiveItems() } catch { console.log('E')}
          this.choicesInstanceDepartureUBN.disable()
        }
      } else {
        if (typeof window !== 'undefined' && this?.choicesInstanceDepartureUBN) {
          this.choicesInstanceDepartureUBN.enable()
        }
      }
    })
  
    
    const displayText = (f) => {
      let parts = [];

      if (f.studbookNumber) parts.push(f.studbookNumber);
      if (f.animalNumber) parts.push(f.animalNumber);
      if (f.name) parts.push(`(${f.name})`);
      if (f.arrivalDate) {
        parts.push(`<span style="color: green">${f.arrivalDate}</span>`);
      }
      if (f.breedCode) parts.push(`(${f.breedCode})`);
      return parts.join(' | ');
    }
    
    const showPastDateWarning = computed(() => {
      if (!state.departureDate) return false;

      const selectedDate = new Date(state.departureDate);
      const today = new Date();
      const diffInDays = (today - selectedDate) / (1000 * 60 * 60 * 24);
      
      return diffInDays > 7;
    });

    const wasValidated = ref(false);

    return {
        state,                
        displayText,
        isDepartureUbnSelected,
        isDepartureUbnTyped,
        wasValidated,
        showPastDateWarning,        
      }
  },  
  watch: {
      'state.departureUbn'(val) {
        const inst = this.choicesInstanceDepartureUBN;
        if (!inst) return;

        if (val && val.trim()) {
          try { inst.removeActiveItems(); } catch(_) { console.log('Error')}
          this.state.departureUbnId = '';
          inst.disable();
        } else {
          inst.enable();
        }
      },

      // optional: if dropdown gets selected (e.g., pre-filled), you can also clear text
      'state.departureUbnId'(val) {
        if (val) this.state.departureUbn = '';
      }
  },
  components: {      
  },  
  async mounted() {  
      this.id = this.$route.params.id;
      this.type = this.$route.params.type;
      
      try {
            this.$store.commit('setShowLoading', true);
            await this.fetchDepartureData(this.id);            
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
    },    
    methods: {              
      async fetchDepartureData(groupGuid) {
        try {
            const response = await axios.get(`departure/groupoverview/${groupGuid}`);
            this.gets = response.data;
            
            if (this.gets.success) {
                this.state.departure = this.gets.data;
                this.state.occurrenceDate = this.state.departure.occurrenceDate;
                this.state.departureFromLocation = this.state.departure.departureFromLocation;
                this.state.departureToLocation = this.state.departure.departureToLocation;
                this.state.departureToUBN = this.state.departure.departureToUBN;
                this.state.exportCountry = this.state.departure.exportCountry;
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
      },
    }   
  };
  </script>
  <style scoped>
  .card {
    transition: background-color 0.2s ease-in-out;    
    position: relative;
    padding: 10px !important;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .bg-light {
    background-color: #f9f9f9 !important;
  }
  .border-success {
    border-color: #28a745 !important;
  }
</style>